import React from "react";
import { Router, Route, Switch } from 'react-router-dom';
import Expense_Tracker from "../components/Expense_Tracker/Expense_Tracker";
import Edit_Transaction_Page from "../components/Expense_Tracker/Edit_Transaction_Page";
import Login from "../components/Expense_Tracker/Login";
import createHistory from "history/createBrowserHistory";
import PrivateRoute from "./PrivateRoute";

export const history = createHistory();

const Application_Routes = () => {
  return (
      <Router history={history}>
          <div>
              <Switch>
                  <Route path="/" component={Login} exact={true} />
                  <PrivateRoute path="/dashboard" component={Expense_Tracker} exact={true} />
                  <PrivateRoute path="/edit_transaction/:id" component={Edit_Transaction_Page} exact={true} />
              </Switch>
          </div>
      </Router>
  )
};

export default Application_Routes;